/* istanbul ignore next */
export function getCurrentYear(): number {
	return new Date().getFullYear();
}
